import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BusApiService } from 'src/app/services/api/bus-api.service';

@Component({
  selector: 'app-adobe-team-modal',
  templateUrl: './adobe-team-modal.component.html',
  styleUrls: ['./adobe-team-modal.component.scss'],
})
export class AdobeTeamModalComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<AdobeTeamModalComponent>,
    private api: BusApiService
  ) {}

  close() {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.findTeam();
  }

  loading = false;
  teams: any;
  async findTeam() {
    try {
      this.loading = true;
      const r = await this.api.findAdobeTeam();
      this.teams = r.data;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
